<template>
  <div class="container">
    <div class="logo">
      <img :src="this.publicData.serverUrl + 'images/logo @2x.png'" alt="" />
      <i class="el-icon-error" @click="goBack"></i>
    </div>
    <div class="login">
      <div class="login-type">
        <div class="login-type-item active">
          {{ $t('lang.external.login.登录') }}
        </div>
        <div class="login-type-item" @click="goRegister">
          {{ $t('lang.external.register.注册') }}
        </div>
      </div>
      <el-form
        :model="loginForm"
        :rules="loginRules"
        ref="loginFormRef"
        class="login-form"
      >
        <el-form-item prop="userName">
          <el-input
            v-model="loginForm.userName"
            :placeholder="$t('lang.external.login.请输入手机号/用户名/邮箱')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/zh@2x.png'"
                alt=""
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="userPassword">
          <el-input
            type="password"
            v-model="loginForm.userPassword"
            :placeholder="$t('lang.external.login.请输入6-11位密码')"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/mm@2x.png'"
                alt=""
              />
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item prop="captcha">
          <el-input
            v-model="loginForm.captcha"
            :placeholder="$t('lang.external.login.点击图片输入验证码')"
            v-on:keyup.enter.native="handleLogin"
          >
            <template slot="prefix">
              <img
                class="prefix-img"
                :src="this.publicData.serverUrl + 'images/yzm@2x.png'"
                alt=""
              />
            </template>
          </el-input>
          <div class="captcha-img" v-loading="captchaLoading">
            <img @click="getCaptCha" :src="captchaImg" alt="" />
          </div>
        </el-form-item> -->
        <el-form-item class="els">
          <el-radio-group v-model="model">
            <el-radio :label="0">{{ $t('lang.external.login.学生') }}</el-radio>
            <el-radio :label="1">{{ $t('lang.external.login.评审') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="login-btns">
        <span class="btn" @click="handleLogin">
          {{ $t('lang.external.login.立即登录') }}
        </span>
        <span class="login-btns-forget">{{
          $t('lang.external.login.忘记密码?')
        }}</span>
      </div>
    </div>
    <LanguageLogin />
  </div>
</template>

<script>
import { login, captcha } from '@/api/user/user'
import LanguageLogin from '@/components/experimentation/languageLayout/language-login'
export default {
  name: 'login',
  components: { LanguageLogin },
  props: [],
  data() {
    return {
      loginForm: {
        userName: '',
        userPassword: '',
        // captcha: '',
        // captchaKey: '',
      },
      loginRules: {
        userName: [
          {
            required: true,
            message: this.$t('lang.external.login.请输入手机号/用户名/邮箱'),
            trigger: 'blur',
          },
        ],
        // captcha: [
        //   {
        //     required: true,
        //     message: this.$t('lang.external.login.请输入验证码'),
        //     trigger: 'blur',
        //   },
        // ],
        userPassword: [
          {
            required: true,
            message: this.$t('lang.external.login.长度在6到11个字符'),
            trigger: 'blur',
          },
          {
            min: 6,
            max: 11,
            message: this.$t('lang.external.login.长度在6到11个字符'),
            trigger: 'blur',
          },
        ],
      },
      isLogin: true,
      captchaImg: this.publicData.serverUrl + 'images/vnum.png',
      captchaLoading: false,
      model: 0,
    }
  },
  filters: {
    loginss: function (v) {
      return v + '改变'
    },
  },
  watch: {
    model(n) {
      if (n === 1) {
        this.loginForm.userName = 'test'
        this.loginForm.userPassword = '123456'
      } else {
        if (this.loginForm.userName != 'test') return
        this.loginForm.userName = ''
        this.loginForm.userPassword = ''
      }
    },
  },
  computed: {},
  created() {
    window.localStorage.setItem('path', this.$route.path)
    // let token = window.localStorage.getItem('token')
    // if (token) return this.$router.go(-1)
    // this.getCaptCha()
  },
  mounted() {},
  methods: {
    goRegister() {
      this.$router.push('/register')
    },
    getCaptCha() {
      this.captchaLoading = true
      captcha()
        .then((res) => {
          const { img, key } = res.data
          this.captchaImg = img
          this.loginForm.captchaKey = key
          this.captchaLoading = false
        })
        .catch(() => {
          this.captchaLoading = false
        })
    },
    goBack() {
      let url = document.referrer
      let history
      if (process.env.NODE_ENV !== 'development') {
        history = url.search(/jzwh.11dom.com/i)
      } else {
        history = url.search(/192.168.8/i)
      }
      if (history == -1) {
        window.localStorage.setItem('expId', 1)
        this.$router.push({ name: 'Experiment', query: { id: 1 } })
      } else {
        this.$router.go(-1)
      }
    },
    handleLogin() {
      console.log(this.loginForm)
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        await login(this.loginForm).then((res) => {
          const { token } = res.data
          window.localStorage.setItem('token', token)
          this.$notify({
            type: 'success',
            message: '登录成功！',
            duration: 1500,
            title: 'SUCCESS',
          })
          this.$store.commit('SETUSERLOGIN', true)
          this.goBack()
          // window.location.reload()
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: var(--logo-bg);
  background-size: 100% 100%;
  color: #888888;
  font-size: 16px;
  .logo {
    padding: 3.7962vh 3.125vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      height: 5.3vh;
    }
    i {
      color: #f4f8fa;
      font-size: 2.1875vw;
      &:hover {
        color: #8c413f;
        cursor: pointer;
      }
    }
  }
  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30%;
    padding: 40px;
    box-sizing: content-box;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    &-type {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 25px;
      &-item {
        margin: 0 60px;
        padding-bottom: 10px;
        border-bottom: 3px solid rgba(255, 255, 255, 0.95);
        cursor: pointer;
      }
      .active {
        font-size: 20px;
        font-weight: bold;
        color: #0c5893;
        border-bottom: 3px solid #0c5893;
      }
    }
    &-form {
      .el-input {
        font-size: 16px;
      }
      ::v-deep .el-input__inner {
        border: none;
        color: #888888;
        background-color: #e4eaf0;
        height: 50px;
        line-height: 50px;
        padding-left: 40px;
      }
      .prefix-img {
        height: 35%;
      }
      .captcha-img {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        padding: 2px;
        border-radius: 3px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          border: 1px solid white;
          border-radius: 3px;
        }
      }
      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #0c5893;
        background: #0c5893;
      }
      ::v-deep .el-radio__input.is-checked + .el-radio__label,
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #0c5893;
      }
    }
    &-btns {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 6.25vh;
      .btn {
        background-color: #0c5893;
        line-height: 3;
        border-radius: 25px;
      }
      &-forget {
        color: #0c5893;
        margin-top: 22px;
        text-decoration: underline;
      }
    }
  }
}
</style>

<style lang="scss">
.login-form {
  .el-input__prefix {
    left: 10px;
    line-height: 50px;
  }
  .el-input-group__append {
    padding: 0;
    border: 0;
    cursor: pointer;
  }
  .els {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>